export default "/static/media/60708668eeeb02359d5589da2368bc83.png";